const errorMessages = {
    NETWORK_ERROR: "خطأ في الاتصال بالشبكة. يرجى التحقق من اتصال الإنترنت الخاص بك. او حاول مرة اخرى لاحقا",
    INVALID_CREDENTIALS: "خطأ في رقم المستخدم او كلمة المرور۔",
    SERVER_ERROR: "حدث خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً.",
    NOT_FOUND: "لم يتم العثور على الطلب",
    UNAUTHORIZED: "غير مصرح لك بالوصول إلى هذه الصفحة. يرجى تسجيل الدخول.",
    FORBIDDEN: "ليس لديك الصلاحية للوصول إلى هذه الصفحة.",
    FORM_VALIDATION_ERROR: "توجد أخطاء في البيانات المدخلة. يرجى تصحيح الأخطاء والمحاولة مرة أخرى.",
    SESSION_EXPIRED: "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    UPLOAD_FAILED: "فشل تحميل الملف. يرجى المحاولة مرة أخرى.",
    UNKNOWN_ERROR: "حدث خطأ غير معروف. يرجى المحاولة مرة أخرى.",
    LOGIN_FAILED:"حدث خطأ اثناء تسجيل الدخول",
    FETCH_DATA_ERROR :" حدث خطأ اثناء جلب البيانات "
  };
  
  export default errorMessages;
  